import React from 'react';

export default class depositAndFees extends React.Component {
  render() {
    // TODO deposit and fees
    return <div>deposit and fees</div>;
  }
}
